// Instead of creating a long list of options, we can use a function to generate the options for the Sqr Ft.
export const squareFeetOptions = Array.from(
	{ length: (5000 - 500) / 100 + 1 },
	(_, i) => `${500 + i * 100}`,
);

export const yearBuiltOptions = Array.from({ length: 100 }, (_, i) =>
	i !== 99
		? `${new Date().getFullYear() - i}`
		: `${new Date().getFullYear() - i} or before`,
);
